<template>
    <div class="body">
        <!--导航栏-->
        <mslNav></mslNav>
        <!-- banner -->
        <div class="swiper_1">
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide v-for="item in bannerPic" :key="item.id">
<!--                    <router-link to="./production_detail">-->
                        <div class="banner r_position pointer">
                          <div class="b_content">
                            <div class="btitle">{{ item.title }}</div>
                            <div class="intro">{{ item.extend }}</div>
                          </div>
                            <img :src="item.pic_path" alt="">
                        </div>
<!--                    </router-link>-->
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!--推荐产品-->
        <div class="pro">
            <div class="p_header column_center">
                <div class="title">推荐产品</div>
                <div class="line"></div>
            </div>
            <div class="list flex flex-dir-left flex-main-center flex-wrap">
                <router-link :to="{ name: 'production_detail', query: { id: aitem.id } }" class="td_none item" v-for="aitem in list[0]" :key="aitem.id">
                    <div>
                        <div class="img_box">
                            <img :src="aitem.image" alt="">
                        </div>
                        <div class="content w">
                            <div class="i_title w d_ellipsis ta_center">{{ aitem.store_name }}</div>
                            <div class="price ta_center">{{ '￥' + aitem.price }}</div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{ name: 'production_detail', query: { id: list[1][0].id } }" class="td_none item" v-if=" list[1] && list[1].length > 0">
                    <div>
                        <div class="img_box">
                            <img :src="list[1][0].image" alt="">
                        </div>
                        <div class="content w">
                            <div class="i_title w d_ellipsis ta_center">{{ list[1][0].store_name }}</div>
                            <div class="price ta_center">{{ '￥' + list[1][0].price }}</div>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="more_area row_center">
                <router-link to="./production" class="td_none">
                    <div class="more">更多商品</div>
                </router-link>
            </div>
        </div>
        <!--企业背景-->
        <div class="enterprise column_center">
            <div class="e_img"></div>
            <div class="e_box">
                <div class="title" v-if="baseInfo.index_backdrop && baseInfo.index_backdrop.id">{{ baseInfo.index_backdrop.title }}</div>
                <div class="intro" v-if="baseInfo.index_backdrop && baseInfo.index_backdrop.id" v-html="baseInfo.index_backdrop.mobile_content"></div>
            </div>
        </div>
        <!--最新资讯-->
        <div class="news">
            <div class="p_header column_center">
                <div class="title">最新资讯</div>
                <div class="line"></div>
            </div>
            <div class="list x_scroll hideScroll">
                <router-link :to="{ name: 'news_detail', query: { id: item.id } }" class="td_none item il_block" v-for="(item, index) in newsList" :key="index">
                    <div class="">
                        <img :src="[ item.image_path ? item.image_path : img ]" alt="">
                        <div class="content">
                            <div class="title w d_ellipsis ta_left">{{ item.title }}</div>
                            <div class="intro w m_ellipsis ta_left">{{ item.content }}</div>
                            <div class="dm space_center">
                                <div class="date">{{ item.create_time }}</div>
                                <div class="check left_center">
                                    <span>查看更多</span>
                                    <span class="iconfont iconicon-22 youjiantou"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="more_area row_center">
                <router-link to="./news" class="td_none">
                    <div class="more">更多资讯</div>
                </router-link>
            </div>
        </div>
        <!--价值理念-->
        <div class="value">
            <swiper ref="mySwiper_2" :options="swiperOptions_2">
                <swiper-slide>
                    <div class="banner r_position pointer">
                        <div class="title">企业愿景</div>
                        <div class="intro mt_6">成就智能健康行业高端优质品牌！</div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="banner">
                        <div class="title">企业发展</div>
                        <div class="intro mt_6">引领技术潮流，不断创新发展！</div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="banner">
                        <div class="title">企业使命</div>
                        <div class="intro mt_6">让更多的人使用上</div>
                        <div class="intro">智能健康的曼稣勒品牌产品</div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <!-- 在线资讯，回到顶部 -->
        <div class="back row_center">
            <onlineBtn @finish="show = $event"></onlineBtn>
            <backTopBtn></backTopBtn>
        </div>
        <!-- 底部 -->
        <mslFooter></mslFooter>
    </div>
</template>

<script>
    import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay, Navigation ,EffectFade,EffectCoverflow} from 'swiper/core'
    SwiperClass.use([Pagination, Mousewheel, Autoplay,Navigation,EffectFade,EffectCoverflow])
    import 'swiper/swiper-bundle.min.css'
    import onlineBtn from '../components/onlineBtn'
    import backTopBtn from '../components/backTopBtn'
    import { indexBanner, baseInfo, hotPro, newsList } from '../api/common.js'

    export default {
        name: "index",
        components: {
            onlineBtn,
            backTopBtn
        },
        data() {
            return {
                img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2F11712326.s21i-11.faiusr.com%2F2%2FABUIABACGAAgpfm_wQUohqX7ugEw2AQ4kAM.jpg&refer=http%3A%2F%2F11712326.s21i-11.faiusr.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1620442895&t=bbc69af68b1ad72e524f805489267869',
                formData: {
                    page: 1,
                    limit: 3,
                    diyname: 'news'
                },
                newsList: [],
                list: [],
                bannerPic: [],
                baseInfo: {},
                show: false,
                swiperOptions: {
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    direction: 'vertical',
                    loop: true,
                    autoplay: {
                        delay: 3000, // 自动切换的时间间隔（单位ms）
                        disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
                    },
                    effect: 'fade',
                    fadeEffect: true,
                    speed: 1000
                },
                swiperOptions_2: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    loop: true
                }
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },
        mounted() {
            this.swiperBanner();
            this.getBaseInfo();
            this.getList();
            this.getNewList();
        },
        methods: {
            async getNewList (page) {
                try {
                    let nList = this.newsList;
                    this.formData.page = page;
                    let data = {
                        ...this.formData
                    }
                    let res = await newsList(data);
                    if (res.code == 1) {
                        nList = res.data.list;
                        this.newsList = nList;
                        this.newsList.forEach((item, index) => {
                            if (!!item.content) {
                                let content = item.content;
                                content = content.replace(/(\n)/g, "");
                                content = content.replace(/(\t)/g, "");
                                content = content.replace(/(\r)/g, "");
                                content = content.replace(/<\/?[^>]*>/g, "");
                                content = content.replace(/\s*/g, "");
                                item.content = content;
                                console.log(item.content, 'item.content');
                            }
                        })
                    }
                } catch {
                    this.errToast('获取资讯数据失败，请刷新');
                }
            },
            getBaseInfo () {
                try {
                    baseInfo().then(res => {
                        if(res.code == 1) {
                            this.baseInfo = res.data;
                            console.log(this.baseInfo, 'this.baseInfo');
                        }
                    })
                } catch {
                    // this.$message.error('获取数据失败，请刷新')
                }
            },
            getList () {
                try {
                    hotPro().then(res => {
                        if (res.code == 1) {
                            this.list = res.data.recommendList
                        }
                        console.log(res, 'res');
                    })
                } catch {
                    this.errToast();
                }
            },
            swiperBanner () {
                indexBanner({
                    type: 'H5',
                    page: 1,
                    limit: 10000
                }).then(res => {
                    if (res.code == 1) {
                        this.bannerPic = res.data;
                    }
                })
            },
            onSwiper(swiper) {
                console.log(swiper);
            },
            onSlideChange() {
                console.log('slide change');
            },
        }
    }
</script>

<style scoped lang="scss">
    .body {
        @media screen and (max-width: 1920px) {
            .swiper_1 {
                .swiper-container {
                    width: 100%;
                    height: 375px;
                    &::v-deep {
                        .banner {
                            width: 100%;
                            height: 375px;
                            overflow: hidden;
                            background-color: #fff;
                          position: relative;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                      .b_content {
                        text-align: center;
                        width: 100%;
                        padding: 0 35px;
                        padding-top: 58px;
                        box-sizing: border-box;
                        position: absolute;
                        top: 0;
                        left: 0;
                        .btitle {
                          text-align: center;
                          font-size: 24px;
                          font-weight: bold;
                          line-height: 28px;
                          color: #333333;
                          margin:0!important;
                        }
                        .intro {
                          text-align: center;
                          width: 340px;
                          margin-top: 4px;
                          font-size: 14px;
                          font-weight: 400;
                          line-height: 22px;
                          color: #8C8C8C;
                        }
                      }
                    }
                }
                &::v-deep {
                    .swiper-pagination-bullet {
                        background: #BBBBBB;
                        width: 6px;
                        height: 6px;
                    }
                    .swiper-pagination {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .swiper-pagination-bullet-active {
                        background: #D7D7D7;
                        width: 12px;
                        height: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 6px;
                            height:6px;
                            background-color: #fff;
                            border-radius: 50%;
                        }
                    }
                }

            }
        }


        /* 头部标题 */
        .p_header {
            .title {
                font-size: 16px;
                font-weight: bold;
                line-height: 24px;
                color: #333333;
            }
            .line {
                width: 12px;
                height: 2px;
                margin-top: 12px;
                background-color: #333333;
            }
        }

        /* 推荐产品 */
        .pro {
            width: 100%;
            padding: 32px 16px;
            box-sizing: border-box;
            .list {
                margin-top: 12px;
                .item {
                    width: 48%;
                    margin-right: 4%;
                    margin-bottom: 15px;
                    &:nth-child(2n) {
                        margin-right: 0;
                    }
                    &:nth-last-child(1), &:nth-last-child(2) {
                        margin-bottom: 0;
                    }
                    .img_box {
                        width: 100%;
                        height: 164px;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .content {
                        margin-top: 8px;
                        .i_title {
                            font-size: 14px;
                            font-weight: bold;
                            line-height: 20px;
                            color: #262626;
                        }
                        .price {
                            margin-top: 4px;
                            font-size: 14px;
                            font-family: SF Pro Display;
                            font-weight: 800;
                            line-height: 16px;
                            color: #262626;
                        }
                    }
                }
            }
        }
        /* 更多按钮样式 */
        .more_area {
            margin-top: 36px;
            .more {
                width: 82px;
                height: 32px;
                border: 1px solid #262626;
                border-radius: 2px;
                font-size: 14px;
                font-family: Alibaba PuHuiTi;
                font-weight: 400;
                line-height: 32px;
                color: #262626;
            }
        }

        /* 企业背景 */
        .enterprise {
            width: 100%;
            height: 130px;
            overflow: hidden;
            position: relative;
            .e_img {
                position: absolute;
                top: 0;
                left:0;
                z-index: 0;
                width:100%;
                height: 100%;
                background: url('../assets/images/homepage_bg.png') no-repeat center center;
                background-size: cover;
                filter: blur(10px);
            }
            .e_box {
                position: absolute;
                top: 0;
                left:0;
                z-index: 10;
                padding: 32px;
                box-sizing: border-box;
                background-color: rgba(51, 51, 51, .92);
                width: 100%;
                .title {
                    font-size: 16px;
                    font-weight: bold;
                    line-height: 24px;
                    color: #FFFFFF;
                }
                .intro {
                    margin-top: 6px;
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 18px;
                    color: #FFFFFF;
                    opacity: 0.8;

                    &::v-deep {
                        p {
                            margin-top: 0!important;
                            margin-bottom: 0!important;
                        }
                    }
                }
            }
        }

        /* 最新资讯 */
        .news {
            width: 100%;
            padding: 32px 0;
            box-sizing: border-box;
            .list {
                margin-top: 24px;
                .item {
                    width: 300px;
                    margin-left: 16px;
                    &:last-child {
                        margin-right: 16px;
                    }
                    img {
                        width: 100%;
                        height: 186px;
                    }
                    .content {
                        white-space: normal!important;
                        margin-top: 12px;
                        .title {
                            font-size: 16px;
                            font-family: PingFang SC;
                            font-weight: bold;
                            line-height: 24px;
                            color: #333333;
                        }
                        .intro {
                            margin-top: 4px;
                            font-size: 12px;
                            font-family: PingFang SC;
                            font-weight: 400;
                            line-height: 18px;
                            color: #8C8C8C;
                            display: -webkit-box!important;
                        }
                        .dm {
                            margin-top: 16px;
                            .date {
                                font-size: 12px;
                                font-family: SF Pro Display;
                                font-weight: 400;
                                line-height: 14px;
                                color: #BFBFBF;
                                opacity: 1;
                            }
                            .check {
                                font-size: 12px;
                                font-family: PingFang SC;
                                font-weight: 400;
                                line-height: 17px;
                                color: #61A4FF;
                                .youjiantou {
                                    font-size: 16px;
                                    margin-left: 4px;
                                }
                            }
                        }
                    }
                }
            }
        }

        /* 价值理念 */
        .value {
            .swiper-container {
                width: 100%;
                height: 100%;
            }
            .swiper-slide {
                width: 300px!important;
                height: 156px;
                background-color: #333;
                box-shadow: 0 6px 16px rgba(0, 0, 0, 0.16);
                text-align: center;
                font-size: 18px;
                border-radius: 2px;

                /* Center slide text vertically */
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;
                transition: 300ms;
                transform: scale(0.86);
                opacity: .6;
            }
            .swiper-slide-active,.swiper-slide-duplicate-active{
                transform: scale(1);
                opacity: 1;
            }
            .banner {
                .title {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    line-height: 24px;
                    color: #FFFFFF;
                }
                .mt_6 {
                    margin-top: 6px;
                }
                .intro {
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 18px;
                    color: #FFFFFF;
                    opacity: 0.8;
                }
            }
        }

        /* 在线咨询 回到顶部 */
        .back {
            width: 100%;
            padding: 24px 0;
            box-sizing: border-box;
        }

    }
</style>
